import { SchmancyElement } from '@schmancy/mixins/index'
import { css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { cache } from 'lit/directives/cache.js'

type SlideType = 'image' | 'video' | 'content'

/** Maps to CSS object-fit. */
type ObjectFit = 'cover' | 'contain' | 'fill' | 'scale-down' | 'none'

@customElement('schmancy-slide')
export class SchmancySlide extends SchmancyElement {
	static styles = [
		css`
			:host {
				display: block;
				scroll-snap-align: center;
			}

			.slide {
				display: block;
				width: 100%;
				height: auto;
				object-fit: var(--object-fit, cover);
			}
		`,
	]

	@property({ type: String }) type: SlideType = 'content'
	@property({ type: String }) src: string = ''
	@property({ type: String }) alt: string = ''
	@property({ type: Boolean }) controls = true
	@property({ type: Boolean }) autoplay = false
	@property({ type: Boolean }) loop = false
	@property({ type: Boolean }) muted = false
	@property({ type: String }) fit: ObjectFit = 'cover'

	render() {
		return html` <div style="--object-fit: ${this.fit}">${cache(this.renderSlide())}</div> `
	}

	private renderSlide() {
		switch (this.type) {
			case 'image':
				return html` <img class="slide" src="${this.src}" alt="${this.alt}" loading="lazy" /> `
			case 'video':
				return html`
					<video
						class="slide"
						src="${this.src}"
						?controls="${this.controls}"
						?autoplay="${this.autoplay}"
						?loop="${this.loop}"
						?muted="${this.muted}"
					>
						Your browser does not support HTML video.
					</video>
				`
			case 'content':
			default:
				return html`<slot></slot>`
		}
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-slide': SchmancySlide
	}
}
